/**
 * Copyright © Veeam Software Group GmbH.
 */

import { VacInternalItemType as VacInternalItemTypeModel } from '@veeam-vspc/models/web-controllers';

export const CheckItemExistType = VacInternalItemTypeModel;
export type CheckItemExistType = VacInternalItemTypeModel;
